import { motion } from "framer-motion";
import { GraduationCap } from "lucide-react";

const educationData = [
    {
        degree: "High School Diploma",
        institution: "Freehold Township High School",
        date: "2022 - 2026",
    }
];

function Education() {
    return (
        <div className="py-12 bg-white">
            <div className="max-w-5xl mx-auto px-4">
                <h2 className="text-3xl font-bold mb-8 flex items-center gap-2">
                    <GraduationCap /> Education
                </h2>
                <div className="flex flex-col space-y-6">
                    {educationData.map((edu, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, x: 30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            className="p-4 bg-gray-50 rounded-2xl shadow"
                        >
                            <h3 className="text-xl font-semibold mb-1">{edu.degree}</h3>
                            <p className="text-gray-700">{edu.institution}</p>
                            <p className="text-gray-700">{edu.date}</p>
                            { edu.minor && <p><em>Minor: {edu.minor}</em></p> }
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Education;